import React, { useState } from 'react';
import { IMediaUploadButton } from "../type/events.types";
import { CameraOutlined } from "@ant-design/icons";
import events from "../../../resources/event";
import UploadDocumentModal from "../../common/upload-document-modal/upload-document-modal";
import { Document } from "../../../domains/models/document";
import { Document_Type } from "../../../constant/constant";
import { uploadEventPhotos } from "../action/events.actions";
import "../../../styles/component/events.scss"


const documentTypeMap: Record<string, keyof typeof Document_Type> = {
    BIRTHDAY:"BIRTHDAY_PHOTO",
    CUSTOM_EVENT:"EVENT_PHOTO",
    WORK_ANNIVERSARY:"WORK_ANNIVERSARY_PHOTO",
    TRAINING:'TRAINING_PHOTO',
    // birthdays: "BIRTHDAY_PHOTO",
    // workAnniversaries: "WORK_ANNIVERSARY_PHOTO",
    // events: "EVENT_PHOTO",
    // trainingEvents: 'TRAINING_PHOTO'
};

const MediaUploadButton: React.FC<IMediaUploadButton> = (props) => {

    const [open, setOpen] = useState(false);
    const resource = events;

    function closeUploadModal() {
        setOpen(false);
    }


    async function handleUploadedFileRes(res: Document[]) {
        const documentIds = res.map((item) => item.id);
        await uploadEventPhotos(props.event.id, documentIds);
    }



    const documentType = documentTypeMap[props.event.eventType];



    return (
        <>
            <button className={`hrms-events__action-btn media-upload-btn ${props.className}`}
                    onClick={() => {
                        if (props.onClick) props.onClick();
                        setOpen(true)
                    }}
            >
                <CameraOutlined/>
                {resource.addPhotoButtonText}
            </button>

            {open && <UploadDocumentModal
                open={open}
                showDocumentList={false}
                documentType={documentType as keyof typeof Document_Type}
                allowMultiple={true}
                handleModalClose={closeUploadModal}
                handleUploadedFileRes={handleUploadedFileRes}
            />
            }

        </>

    )


}

export default MediaUploadButton;
